/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
  MessageHeader, Message,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
// import Results from "./Results.js";

// import MyCarousel from "./Carousel.js";
// import Video from './Video.js';
import YouTube from './YouTube.js';
// import overview from "./images/framework-crop-1.jpg";
// import teaser from './images/teaser.png';
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";
// import MyCarousel from "./Carousel.js";
// import fig_noisy from './images/fig_noisy.jpg'
import './App.css'
import mode from './images/mode.png'
import res from './images/res.png'
import teaser from './images/teaser.png'
import time from './images/time.png'
import method from './images/method.png'

import LazyVideo from "./lazy-video";
import result from './images/trimmed.mp4';
import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' 


const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      Taming Mode Collapse in Score Distillation for Text-to-3D Generation
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const Authors = () => (      <Container text>
  {/* <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
  </Grid> */}
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}

    {/* </Grid.Column> */}
    {/* <Grid.Column> */}
    <a href="https://peihaowang.github.io//" target="_blank" rel="noreferrer">
    Peihao Wang<sup>1</sup>
    </a>
    <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
      Dejia Xu<sup>1</sup>
    </a>
    <a href="https://zhiwenfan.github.io/" target="_blank" rel="noreferrer">
    Zhiwen Fan<sup>1</sup>
    </a>
    <a href="https://wdilin.github.io/" target="_blank" rel="noreferrer">
    Dilin Wang<sup>2</sup>
    </a>
    <a href="https://sreyas-mohan.github.io/" target="_blank" rel="noreferrer">
    Sreyas Mohan<sup>2</sup>
    </a>
    <a href="http://forrestiandola.com/" target="_blank" rel="noreferrer">
    Forrest Iandola<sup>2</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
    Rakesh Ranjan<sup>2</sup>
    </a>
    <a href="#" target="_blank" rel="noreferrer">
    Yilei Li<sup>2</sup>
    </a>
    <a href="https://www.cs.utexas.edu/~lqiang//" target="_blank" rel="noreferrer">
    Qiang Liu<sup>1</sup>
    </a>
    <a
      href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
      target="_blank"
      rel="noreferrer"
    >
      Zhangyang Wang<sup>1</sup>
    </a>
    <a href="https://v-chandra.github.io/" target="_blank" rel="noreferrer">
    Vikas Chandra<sup>2</sup>
    </a>
    {/* </Grid.Column> */}
    {/* </Grid.Row> */}
  </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  >
    <div>
      <sup>1</sup> The University of Texas at Austin, <sup>2</sup> Meta Reality Labs
    </div>
  {/* </Grid>
  <Grid
    container
    stackable
    verticalAlign="middle"
    columns={4}
    textAlign="center"
    style={{
      fontSize: "1em",
      fontWeight: "normal",
      marginTop: "0.5em",
      marginBottom: "0.5em",
    }}
  > */}
    {/* <br /> */}
    {/* <div>*denotes equal contribution</div> */}
  </Grid>
  <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon>
              <a
                href="https://arxiv.org/abs/2401.00909"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon>
              <a
                href="https://github.com/VITA-Group/3D-Mode-Collapse"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
</Container>
)

const str = `~~~shell
python launch.py --config configs/prolificdreamer.yaml --train --gpu 0
system.prompt_processor.prompt=<your_prompt>
~~~
`
const strBold = `~~~
python launch.py --config configs/prolificdreamer.yaml --train --gpu 0
system.prompt_processor.prompt=<your_prompt> **system.guidance.guidance_scale_lora=0.5**
~~~
`

const mathStr = `How to fix this problem? As KL divergence can be written as:

$$
D_{KL}(q \\Vert p) = \\mathbb{E}_{q}[\\log q] - \\mathbb{E}_{q}[\\log p] = -J_{MLE}[q] - H[q]
$$

we reveal that mode collapse is due to the missing entropy term in KL divergence when
using SDS and VSD. Our remedy is to simply add it back:

$$
J_{Ent} = -J_{MLE}[q] - \\lambda H[p]
$$

Surprisingly, the new score distillation optimizing for $J_{Ent}$  can be derived as adopting CFG
trick on VSD:

$$
\\nabla J_{Ent} = \\mathbb{E} \\left[\\frac{\\partial x}{\\partial \\theta} \\left(\\nabla \\log p(x | y) - \\lambda \\nabla \\log q(x | \\emptyset) - (1-\\lambda) \\log q(x | c) \\right) \\right]
$$
`

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Authors />

      <Container text>
      {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Overview
        </Header> */}
        {/* <MyCarousel mobile={mobile} ></MyCarousel> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        TL;DR
        </Header>
        {/* <p></p> */}
        Experiencing the Janus problem when you run <a href="https://github.com/threestudio-project/threestudio" target="_blank"
                rel="noreferrer">threestudio</a> with the following
command for text-to-3D generation?
<Message info color='yellow'>
    {/* <MessageHeader></MessageHeader> */}
<pre>
python launch.py --config configs/prolificdreamer.yaml --train --gpu 0
system.prompt_processor.prompt=your_prompt
</pre>
    {/* <p></p> */}
  </Message>
  <p>
  Our theoretical finding suggests simply adding the flag <i><b>system.guidance.guidance_scale_lora=0.5</b></i> can potentially relieve Janus problem. Have it a
try!
  </p>
    
  <Message info color='green'>
    {/* <MessageHeader></MessageHeader> */}
    {/* <p>Did you know it's been a while?</p> */}
    <pre>
python launch.py --config configs/prolificdreamer.yaml --train --gpu 0
system.prompt_processor.prompt=your_prompt <b>system.guidance.guidance_scale_lora=0.5</b>
</pre>
    {/* <p></p> */}
  </Message>
<i>Note: The value of this hyperparameter may vary in different scenarios. Check our <a href="https://github.com/VITA-Group/3D-Mode-Collapse" target="_blank"
                rel="noreferrer">code
                repo</a> for more implementation details</i>
        {/* <br></br> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        More Comparisons
        </Header>
        <LazyVideo src={result} no_control></LazyVideo>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Rationale
        </Header>
        <p>
        Score distillation optimizes for the KL divergence between rendered image distribution and
pre-trained image distribution. However, SDS and VSD degenerate to maximal-likelihood
estimation (MLE).
        <br></br>
        As illustrated below, compared with KL divergence, MLE opts for mode collapse. Mode
collapse finally manifests as Janus problem when all views collapse to the most commonly
seen view.
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Illustration of the effect of entropy regularization
        </Header>
        <Image src={mode} style={subsection_style} centered="true" ></Image>
        <div>
        <ReactMarkdown remarkPlugins={[remarkMath]}
    rehypePlugins={[rehypeKatex]} textAlign="center"
>{mathStr}</ReactMarkdown> 
    </div>
        <p>Please refer to our <a href="https://arxiv.org/abs/2401.00909" target="_blank"
                rel="noreferrer">paper</a> for a more rigorous argument.</p>
        {/* <Comparison /> */}
        {/* <Results /> */}
        {/* <Abstract mobile={mobile} style={{textAlign: "justify",}} /> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Visualizations
        </Header> */}
        {/* <MyCarousel mobile={mobile} /> */}
        {/* <Video /> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
        Method
        </Header>
        <Image src={method} style={subsection_style} centered="true" ></Image> */}
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
        Results
        </Header>
        <p>
        Our proposed outperforms all baselines in terms of better geometry and well-constructed texture details. Our results deliver photo-realistic and diverse rendered views, while baseline methods more or less suffer from the Janus problem.
        </p>
        
        <p>
        We present the front and back views of objects synthesized by VSD (ProlificDreamer) on the right two columns, and four views of our generated results on the left. VSD suffers from ``Janus'' problem, where both front and back views contain a frontal face of the targeted object, while our method effectively mitigates this artifact.
        </p>
        <Image src={teaser} style={subsection_style} centered="true" ></Image>
        <p>
        We combine our proposed ESD with timestep scheduling in DreamTime and compare it against baseline methods. Prompt: A caramic lion.
        <br></br>
        <Image src={time} style={subsection_style} width="60%" centered="true" ></Image>
        </p> */}
        {/* <Image src={fig_noisy} style={subsection_style}></Image> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If you want to cite our work, please kindly use:
          <pre>
            <code>
              {`@article{wang2024esd,
  title={Taming Mode Collapse in Score Distillation for Text-to-3D Generation},
  author={Wang, Peihao and Xu, Dejia and Fan, Zhiwen and Wang, Dilin and Mohan, Sreyas and Iandola, Forrest and Ranjan, Rakesh and Li, Yilei and Liu, Qiang and Wang, Zhangyang and Chandra, Vikas},
  journal={arXiv preprint: 2401.00909},
  year={2024}
}\}`}
            </code>
          </pre>
        </p>
        <Header as="h2" textAlign="center" style={subsection_style}>
        Relevant Works
        </Header>
        <Message info color='teal'>
    <MessageHeader> <a href="https://vita-group.github.io/SteinDreamer/" target="_blank" rel="noreferrer">
    SteinDreamer: Variance Reduction for Text-to-3D Score Distillation via Stein Identity
    </a></MessageHeader>
    We adopt control variate method constructed by Stein identity to reduce variance in Monte Carlo estimation for text-to-3D score distillation.
  </Message>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/4DGen/" target="_blank" rel="noreferrer">
    4DGen: Grounded 4D Content Generation with Spatial-temporal Consistency
    </a></MessageHeader>
    We introduce grounded 4D content generation. We identify static 3D assets and monocular video sequences as key components in constructing the 4D content. 
  </Message>
        <Message info color='teal'>
    <MessageHeader><a href="https://vita-group.github.io/NeuralLift-360/" target="_blank" rel="noreferrer">
    NeuralLift-360: Lifting An In-the-wild 2D Photo to A 3D Object with 360° Views
    </a></MessageHeader>
    We derive a prior distillation loss for CLIP-guided diffusion prior and utilize rough depth estimation in the wild with the help of a ranking loss.
  </Message>
        <br></br>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
